import { render, staticRenderFns } from "./training.vue?vue&type=template&id=3733f0c0"
import script from "./training.vue?vue&type=script&lang=js"
export * from "./training.vue?vue&type=script&lang=js"
import style0 from "./training.vue?vue&type=style&index=0&id=3733f0c0&prod&lang=scss"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports